import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './List.module.scss';
import Button from '../Button';
import SimpleInput from '../SimpleInput';

export default function List(props) {
  const { onChange, addText } = props;
  const [items, setItems] = useState(props.items.length ? props.items : ['']);

  const handleChange = (index, value) => {
    const newItems = [...items];
    newItems[index] = value;
    setItems(newItems);
    onChange(newItems);
  };

  const addItem = () => {
    setItems([...items, '']);
  };

  const removeItem = (index) => {
    const newItems = items.filter((item, i) => i !== index);

    if (!newItems.length) {
      newItems.push('');
    }

    setItems(newItems);
    onChange(newItems);
  };

  return (
    <div className={styles.list}>
      <ul>
        {items.map((item, i) => (
          <li key={i}>
            <SimpleInput value={item} onChange={(e) => handleChange(i, e.target.value)} />
            <span className={cn(styles.icon, 'ic-close')} onClick={() => removeItem(i)} />
          </li>
        ))}
      </ul>

      <Button link text={addText} onClick={addItem} />
    </div>
  );
}

List.defaultProps = {
  items: [],
  addText: 'Add Item',
};

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  addText: PropTypes.string,
  onChange: PropTypes.func,
};
